var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("世界疫情地图")]),_c('div',{staticStyle:{"width":"7.5rem","height":"7rem"},attrs:{"id":"main"}})])
}]

export { render, staticRenderFns }